import { useQuery } from '@tanstack/react-query';
import { familyService } from '../api/familyService';
import { UserStatus } from '../types/enums';

interface MyFamiliesData {
  user: {
    workosUserId: string;
    email: string;
    firstName: string;
    lastName: string;
  };
  families: Array<{
    id: string;
    name: string;
    status: UserStatus;
  }>;
}

export const useMyFamilies = () => {
  const { data, isLoading, error, refetch } = useQuery<MyFamiliesData, Error>({
    queryKey: ['myFamilies'],
    queryFn: () => familyService.getMyFamilies(),
    staleTime: Infinity, // Data never becomes stale automatically
    refetchOnMount: false, // Don't refetch on mount - use refresh button instead
    refetchOnWindowFocus: false, // Don't refetch when window regains focus
  });

  return {
    data: data ?? null,
    loading: isLoading,
    error: error?.message ?? null,
    refetch,
    user: data?.user,
    families: data?.families || [],
  };
};
